import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import { MenuItem, MenuSection } from '../models/rich-data.model';

@Pipe({
  name: 'isComing'
})
export class IscomingPipe implements PipeTransform {

  transform(events: MenuSection[]): MenuItem[] {

    let itemdata = [];

    events.forEach(eventdata => {
      if (eventdata.menu_categories) {
        eventdata.menu_categories.forEach(cat => {
          if (cat.menu_items) {
            cat.menu_items.forEach(event => {
              if(eventdata.id === 117) {
                itemdata.push(event);
              }
              if (event.active && event.menu_item_books) {
                event.menu_item_books.forEach(book => {
                  if (book.menu_item_book_details) {
                    book.menu_item_book_details.forEach(books => {

                      const UTC = dayjs(new Date()).utcOffset();

                      const START = dayjs(new Date()).set('hour', +dayjs(books.start_time).format('HH'))
                        .set('minute', +dayjs(books.start_time).format('mm')).set('second', 0).add(-(UTC + 30), 'minutes').toDate();

                      let END = dayjs(new Date()).set('hour', +dayjs(books.end_time).format('HH'))
                        .set('minute', +dayjs(books.end_time).format('mm')).set('second', 0).add(-(UTC + 30), 'minutes').toDate();

                      if (dayjs(START).diff(END) > 0) {
                        END = dayjs(END).add(1, 'days').toDate();
                      }

                      if (book[dayjs(new Date()).format('dddd').toLocaleLowerCase()] &&
                        dayjs(new Date()).diff(START) >= 0 && dayjs(new Date()).diff(END) <= 0) {
                        event.end_time = `${dayjs(END).add(30, 'minute').format('HH:mm')}`;
                        itemdata.push(event);
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    itemdata = [...new Set(itemdata)];
    return itemdata;
  }
}
